import { getAxiosClient } from "../../axios-client";
import { PricelistGetAllByIdRequestBody, PricelistGetAllByIdResponse } from "./types";

const axiosClient = getAxiosClient();
export const pricelistGetAllById = async (body: PricelistGetAllByIdRequestBody) => {
  return await axiosClient.ax.post<PricelistGetAllByIdResponse>(
    "Pricelist/GetAll",
    body
  );
};
